import React from 'react';
import { Box } from '@react-three/drei';
import ProductDisplay from './ProductDisplay';

const ShelfUnit = ({ 
  position = [0, 0, 0], 
  rotation = [0, 0, 0], 
  size = [2, 1.8, 0.4], 
  type = 'standard',
  items = [] 
}) => {
  const [width, height, depth] = size;
  const shelfLevels = Math.floor(height / 0.4); // Each shelf level is ~40cm

  const getShelfColor = (type) => {
    switch (type) {
      case 'corner': return '#8d6e63';
      case 'endcap': return '#5d4037';
      case 'gondola': return '#6d4c41';
      case 'wall': return '#795548';
      default: return '#a1887f';
    }
  };

  return (
    <group position={position} rotation={rotation}>
      {/* Shelf Frame */}
      <Box
        args={[width, height, depth]}
        position={[0, height / 2, 0]}
        castShadow
        receiveShadow
      >
        <meshStandardMaterial color={getShelfColor(type)} />
      </Box>

      {/* Shelf Levels */}
      {Array.from({ length: shelfLevels }, (_, i) => (
        <Box
          key={`shelf-level-${i}`}
          args={[width - 0.1, 0.05, depth - 0.1]}
          position={[0, (i + 1) * (height / shelfLevels), 0]}
          castShadow
          receiveShadow
        >
          <meshStandardMaterial color="#f5f5f5" />
        </Box>
      ))}

      {/* Items on Shelves */}
      {items.map((item, index) => {
        const shelfLevel = Math.floor(index / Math.floor(width));
        const positionOnShelf = index % Math.floor(width);
        const itemPosition = [
          -width / 2 + (positionOnShelf + 0.5) * (width / Math.floor(width)),
          (shelfLevel + 1) * (height / shelfLevels) + 0.5,
          0
        ];

        return (
          <ProductDisplay
            key={`shelf-item-${item.id}-${index}`}
            item={item}
            position={itemPosition}
          />
        );
      })}

      {/* Shelf Type Label */}
      {type !== 'standard' && (
        <Box
          args={[0.2, 0.1, 0.02]}
          position={[width / 2 + 0.1, height - 0.2, 0]}
        >
          <meshStandardMaterial color="#2196f3" />
        </Box>
      )}
    </group>
  );
};

export default ShelfUnit;
